import React from 'react';
import { useTranslation } from '~/dependencies';
import { NewSession } from '~/components/ActiveCall/types';
import { Button, Dialpad } from './styles';

type InCallKeypadButtonProps = {
  onClick: (sessionId: NewSession['id'], dtmf: boolean) => void;
  session: NewSession;
};

const InCallKeypad = ({ onClick, session }: InCallKeypadButtonProps) => {
  const { id: sessionId, answered, dtmf } = session;

  const { t } = useTranslation();

  function clickHandler(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault(); // Prevents default behavior if needed
    onClick(sessionId, !dtmf); // Passes custom arguments
  }

  return (
    <Button
      type="button"
      title={t('components.activeCalls.btn.inCallKeyboard')}
      disabled={!answered}
      onClick={clickHandler}>
      <Dialpad active={dtmf} />
    </Button>
  );
};

export default InCallKeypad;
